import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { StepsDataService, StepsColumnsService, RecipesDataService } from '../../../services';
import { Step, StepsResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-step-form',
  templateUrl: './step-form.component.html',
  styleUrls: ['./step-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class StepFormComponent implements OnInit, OnDestroy, AfterViewInit {
  selectedFile: File | null;

  public step: Step = {};
  public stepForm: FormGroup = new FormGroup({});
  public steps: Step[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();
  public recipeValue:any;
  formData = new FormData();
  public recipes: [] = [];

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private stepsDataService: StepsDataService,
    public stepsColumnsService: StepsColumnsService,
    public recipesDataService: RecipesDataService
  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null

  }

  ngOnInit(): void {
    console.log('ngOnInit', 'StepFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Step - Edit');
        this.getStep(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.step !== 'undefined') {
      this.step = this.dynamicDialogConfig.data.step;
    }
    if (typeof this.step.id === 'undefined' || this.step.id === null) {
      this.step.id = null;
    }
    this.getSteps();
    this.prepareFrom();
    this.getRecipes();
  }
  onChange(e: any) {
    const selectedRecipe = e.value;
    console.log('Selected Recipe:', selectedRecipe);
    
    // Ensure you are storing only the id
    if (selectedRecipe && selectedRecipe.id) {
      this.stepForm.patchValue({ recipe: selectedRecipe });
    }
    console.log('Form after patching recipe id:', this.stepForm.value);
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'StepFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'StepFormComponent');
  }
  getRecipes(): void {
    this.isLoading = true;
 
    this.recipesDataService.getAllRecipes().subscribe((response) => {
      this.isLoading = false;
      if (response !== null) {
        this.recipes = response.success.data;
      }
    }, (error: any) => {;
      this.isLoading = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('UI.ERROR'), detail: this.translate.instant('UI.ApplicationSNOTLOADED')});
    });
  }
  getStep(id: number): void {
    this.isLoading = true;
    this.stepsDataService.getStep(id).subscribe((response: Step|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.step = response;
        this.prepareFrom();
      }
    });
  }

  getSteps(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.steps !== 'undefined' && this.dynamicDialogConfig.data.steps.length > 0) {
      this.steps = this.dynamicDialogConfig.data.steps;
      return;
    }
    this.stepsDataService.getSteps(this.parameters).subscribe((response: StepsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.steps = response.results;
      }
    });
  }

  uploadPhoto(event: any): void {
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('imagePath', this.selectedFile);
    }
  }
  prepareFrom(): void {
    this.stepForm = new FormGroup({
      title: new FormControl(this.step.title, []),
      TitleEn: new FormControl(this.step.TitleEn, []),
      titleFr: new FormControl(this.step.titleFr, []),
      titleAr: new FormControl(this.step.titleAr, []),

      description: new FormControl(this.step.description),
      descriptionAr: new FormControl(this.step.descriptionAr, []),
      descriptionFr: new FormControl(this.step.descriptionFr, []),
      recipe: new FormControl((typeof this.step.recipe === 'number') ? this.step.recipe : this.step.recipe?.id, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/steps']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.stepForm.controls).forEach((field: any) => {
        const control = this.stepForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.stepForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.step = this.stepForm.value;
    this.disableSubmit = true;
    console.log('step', this.step);
    if (typeof this.step.id !== 'undefined' && this.step.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.stepsDataService.updateStep(this.step).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('STEPUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('STEPNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.stepsDataService.addStep(this.step).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('STEPCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('STEPNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }


  openFilerDialog(field: string): void {
    let url = '';
    const control = this.stepForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'steps',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.stepForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-step-form',
  templateUrl: './step-form.component.html',
  styleUrls: ['./step-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogStepFormComponent extends StepFormComponent {
}

